const gtag = (...args) => {
  if (typeof window.gtag === 'function') {
    window.gtag(...args);
  }
};

export const trackEvent = (eventName, params = {}) => {
  gtag('event', eventName, params);
};

export const trackPageView = (pageName) => {
  gtag('event', 'page_view', { page_title: pageName });
};
